// extracted by mini-css-extract-plugin
module.exports = {"inner":"a10a3f92e9--inner--Geo_p","title":"a10a3f92e9--title--vH8da","content":"a10a3f92e9--content--I8qsx","footer":"a10a3f92e9--footer--mZ5z7"};